import { DocumentModel } from 'shared/domain/document/documentModel';
import { UploadStatus } from 'shared/types/uploadStatus';

export function isDocumentRemoteAndUnavailable(
  document: DocumentModel
): boolean {
  // Document is unavailable only if:
  // 1. It exists in backend (_id present)
  // 2. Upload explicitly failed (not UNKNOWN, which is a fallback when backend doesn't send uploadStatus)
  // 3. No local blob URL available
  const uploadStatus = document.data?.uploadStatus;
  const hasExplicitFailure =
    uploadStatus === UploadStatus.failed ||
    uploadStatus === UploadStatus.failedPerm;

  return (
    Boolean(document._id) &&
    hasExplicitFailure &&
    !document.localData
  );
}
